import script from "./download_report.vue?vue&type=script&setup=true&lang=js"
export * from "./download_report.vue?vue&type=script&setup=true&lang=js"

import "./download_report.vue?vue&type=style&index=0&id=72f2228b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f2228b"]])

export default __exports__